module.exports = __webpack_public_path__ + "img/z14.c8ad31d3.png";